{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Шаблони",
    "DESCRIPTION": "Переглядайте шаблони повідомлень, синхронізовані з ваших вхідних WhatsApp. Щоб створити або редагувати шаблон, керуйте ним у свого постачальника.",
    "COUNT": "Кількість шаблонів: {n}",
    "LEARN_MORE": "Дізнатися більше про шаблони WhatsApp",
    "SYNC_TEMPLATES": "Синхронізувати шаблони",
    "SYNC_SUCCESS": "Синхронізацію шаблонів розпочато для всіх вхідних WhatsApp. Оновлення можуть з'явитися протягом кількох хвилин.",
    "PARTIAL_SYNC_ERROR": "Синхронізацію шаблонів розпочато для деяких вхідних WhatsApp, але для інших синхронізація не вдалася.",
    "SYNC_ERROR": "Не вдалося розпочати синхронізацію шаблонів. Спробуйте ще раз.",
    "SEARCH_PLACEHOLDER": "Пошук за вмістом або назвою...",
    "MANAGE_IN_META": "Керувати в Meta",
    "LOADING": "Завантаження шаблонів WhatsApp...",
    "EMPTY": "Шаблонів WhatsApp не знайдено.",
    "NO_RESULTS": "Жоден шаблон не відповідає вашим фільтрам.",
    "FETCH_ERROR": "Не вдалося завантажити шаблони WhatsApp. Спробуйте ще раз.",
    "PARTIAL_FETCH_ERROR": "Деякі шаблони WhatsApp не вдалося завантажити. Спробуйте ще раз.",
    "LAST_SYNC_ATTEMPT": "Остання спроба синхронізації: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Не подано на затвердження WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Усі вхідні",
      "ALL_LANGUAGES": "Усі мови",
      "ALL_TYPES": "Усі типи"
    },
    "TYPES": {
      "TEXT": "Текст",
      "IMAGE": "Зображення",
      "VIDEO": "Відео",
      "DOCUMENT": "Документ",
      "CALL_TO_ACTION": "Заклик до дії",
      "COPY_CODE": "Копіювати код"
    },
    "PREVIEW": {
      "TITLE": "Попередній перегляд шаблону",
      "DESCRIPTION": "Перегляньте, як цей шаблон виглядає у WhatsApp.",
      "OPEN": "Перегляд {name}",
      "CLOSE": "Закрити перегляд",
      "DETAILS": "Деталі шаблону",
      "STATUS": "Статус",
      "TYPE": "Тип вмісту",
      "CATEGORY": "Категорія",
      "LANGUAGE": "Мова",
      "INBOXES": "Вхідні"
    }
  }
}
